import React from 'react';
import { Box, Fade } from '@mui/material';
import {
  CloseupAnimationFab,
  DamageAnimationFab,
  Interior360AnimationFab,
  VideoAnimationFab,
} from '../../components';

import {
  activeTabSet,
  carStatusSet,
  getCarStatus,
  interiorStatusSet,
} from '../../store/car-slice';
import { useDispatch, useSelector } from 'react-redux';
import { useInteriorExist } from '../../hooks/use-interior-exist';

type PropTypes = {
  report: any;
  handleClickHotspot: any;
};

const HotspotList = (props: PropTypes) => {
  const { report, handleClickHotspot } = props;
  const [show, setShow] = React.useState(false);

  let hotspotGroupList = [];

  if (report) {
    hotspotGroupList = report?.map((item: any) => {
      return { ...item, x: 0.7, y: 0.65 };
    });
  }

  return (
    <>
      <VideoAnimationFab onClick={() => setShow((prevState) => !prevState)} />
      <Fade in={show}>
        <Box
          sx={{
            backgroundColor: '#fff',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '5px',
            padding: '.5rem',
            borderRadius: '8px',
          }}
        >
          {hotspotGroupList.map((item: any) => (
            <Box
              key={item.id}
              sx={{
                minWidth: '8rem',
                padding: '1rem',
                cursor: 'pointer',
                transition: '0.3s ease-in-out',
                borderRadius: '5px',
                '&:not(:last-child)': {
                  borderBottom: '1px solid #ddd',
                },
                '&:hover': {
                  backgroundColor: '#eee',
                  boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
                },
              }}
            >
              <Box onClick={(evt: any) => handleClickHotspot(evt, item)}>
                {item?.title || 'hotspot'}
              </Box>
            </Box>
          ))}
        </Box>
      </Fade>
    </>
  );
};

export default function HotspotIcon(props: PropTypes) {
  const { report, handleClickHotspot } = props;

  const { isInteriorExist, isCenterConsoleExist } = useInteriorExist();

  const contentType = report?.contentType;
  const type = report?.type;
  const description = report?.description;

  const carStatus = useSelector(getCarStatus);

  const dispatch = useDispatch();
  // const carStatus = useSelector(getCarStatus);

  const navigateToCar = () => {
    if (carStatus === 'VDP') {
      dispatch(carStatusSet('CAR'));
    }
  };

  const navigateToInterior360 = () => {
    navigateToCar();
    dispatch(activeTabSet('interior'));
    if (isCenterConsoleExist) {
      dispatch(interiorStatusSet('center-console'));
    } else {
      dispatch(interiorStatusSet('back-seat'));
    }
  };

  const clickHotspot = (event: any) => {
    // navigateToCar();
    handleClickHotspot(event, report);
  };

  if (Array.isArray(report) && report?.length > 1) {
    return (
      <HotspotList handleClickHotspot={handleClickHotspot} report={report} />
    );
  }

  if (
    description === process.env.REACT_APP_HOTSPOT_PAYLOAD &&
    isInteriorExist
  ) {
    return <Interior360AnimationFab onClick={navigateToInterior360} />;
  }

  if (
    description === process.env.REACT_APP_HOTSPOT_PAYLOAD &&
    !isInteriorExist
  ) {
    return null;
  }

  if (contentType === 'image' || contentType === 'text') {
    if (type === 'condition' || type === 'damage')
      return (
        <DamageAnimationFab onClick={(event: any) => clickHotspot(event)} />
      );
    else if (type === 'closeup' || type === 'feature')
      return (
        <CloseupAnimationFab onClick={(event: any) => clickHotspot(event)} />
      );
  } else if (contentType === 'video') {
    return <VideoAnimationFab onClick={(event: any) => clickHotspot(event)} />;
  }
}
